type MixpanelEndsWithEventType<S = string> = S extends `${string}${
  | 'Impression'
  | 'impression'
  | 'Click'
  | 'click'
  // From here new types have been created to fit GUM's needs
  | 'Shown'
  | 'shown'
  | 'Clicked'
  | 'clicked'
  | 'Visited'
  | 'visited'
  | 'Metrics'
  | 'Closed'
  | 'Email'
  | 'Modal'
  | 'Term'
  | 'Change'
  | 'change'
  | 'Results'
  | 'Input'
  | 'Tab'}`
  ? string
  : Array<'must end with `impression` or `click`'>; // using Array so the error message is visible

type Traffic<S = string> = S extends `${string}${'impression' | 'click'}`
  ? string
  : Array<'must end with `impression` or `click`'>; // using Array so the error message is visible

export type OnlyFiveOrLessPeriods<S = string, C extends string = ''> = S extends ''
  ? string
  : C extends '.....'
  ? Array<'only 4 dots are allowed'> // using Array so the error message is visible
  : S extends `${infer Head}${infer Tail}`
  ? Head extends '.'
    ? OnlyFiveOrLessPeriods<Tail, `${C}.`>
    : OnlyFiveOrLessPeriods<Tail, C>
  : string;

const getEventType = (message: string) => {
  const result = /(?<event>impression|click)$/.exec(message);
  if (result != null) {
    return result?.groups?.event || 'impression';
  }
  return 'impression';
};

export const mixpanel = <S extends string>(message: S & MixpanelEndsWithEventType<S>) => {
  /**
   * Must end with impression or click
   */
  return { mixpanel: [`${message}`] };
};

export const traffic2 = <S extends string>(message: S & OnlyFiveOrLessPeriods<S> & Traffic<S>) => {
  /**
   * Must end with impression or click, can only have 4 dots
   */
  const eventType = getEventType(message);
  return {
    traffic2: [`${message.toLocaleLowerCase().replace(' ', '.')}`, eventType.toLowerCase()]
  };
};
